import {
  divideADOTConversion,
  formatADOTQuantityWithUnit,
  isADOTBaseUnit,
} from '@atom/components/common/requests/adotReplenishmentUtilities';
import { AssetRequestPurchaseUnit } from '@atom/types/assetRequest';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import classes from './adotView.module.css';

type ADOTConvertedQuantityProps = {
  baseValue: number;
  purchaseUnit: AssetRequestPurchaseUnit;
  dataCy?: string;
};

const ADOTConvertedQuantity = ({
  baseValue,
  purchaseUnit,
  dataCy,
}: ADOTConvertedQuantityProps) => {
  const hasValue = !isNilOrEmpty(baseValue);

  return (
    <div data-cy={dataCy}>
      <div>
        {hasValue
          ? formatADOTQuantityWithUnit(
              divideADOTConversion(baseValue, purchaseUnit),
              purchaseUnit.unit,
            )
          : '-'}
      </div>
      {hasValue && !isADOTBaseUnit(purchaseUnit) && (
        <div className={classes.subtext}>
          {formatADOTQuantityWithUnit(baseValue, purchaseUnit.baseUnit)}
        </div>
      )}
    </div>
  );
};

export default ADOTConvertedQuantity;
